import React from 'react';

export const FileConditions: React.FC = () => {
	return (
		<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M17.5 19.1286V5.87143C17.5 5.63955 17.3244 5.5 17.1667 5.5H7.83333C7.67561 5.5 7.5 5.63955 7.5 5.87143V19.1286C7.5 19.3604 7.67561 19.5 7.83333 19.5H17.1667C17.3244 19.5 17.5 19.3604 17.5 19.1286ZM18.5 19.1286V5.87143C18.5 5.11401 17.903 4.5 17.1667 4.5H7.83333C7.09695 4.5 6.5 5.11401 6.5 5.87143V19.1286C6.5 19.886 7.09695 20.5 7.83333 20.5H17.1667C17.903 20.5 18.5 19.886 18.5 19.1286Z"
				fill="#D1005D"
			/>
			<rect x="9.5" y="9.5" width="6" height="1" rx="0.5" fill="#D1005D" />
			<rect x="9.5" y="7.5" width="6" height="1" rx="0.5" fill="#D1005D" />
			<rect x="9.5" y="11.5" width="6" height="1" rx="0.5" fill="#D1005D" />
		</svg>
	);
};
